// Base class for a world FEATURE: a whole-chunk generation mode the world rolls
// between as you roam — open noise terrain, a void gap, a fortress. To add one,
// subclass Feature, implement getTile(), and register it in the `features` table in
// engine/chunks.js.
export class Feature {
    // The packed tile at world tile (tcx, tri), or undefined for air. `api` carries
    // the generation helpers a feature may need — currently getBiomeBaseTile(), the
    // base material for this location, so a feature blends with the biome it sits in.
    getTile(api, tcx, tri) {
        return undefined;
    }
}
